/** RFC 8628 user codes. React-free: `route.paths.ts` reads this at vite-config time. */

/** Shape the auth-service issues. */
const USER_CODE_PATTERN = /^[A-Z]{4}-[A-Z]{4}$/;

const USER_CODE_HALF = 4;

export const USER_CODE_LENGTH = USER_CODE_HALF * 2;

/** The code's letters, without the separator and capped at the length the auth-service issues. */
export function userCodeLetters(input: string): string {
  return input
    .toUpperCase()
    .replace(/[^A-Z]/g, '')
    .slice(0, USER_CODE_LENGTH);
}

/** "abcd efgh", "ABCDEFGH" and "abcd-efgh" are the same code; only the canonical form resolves. */
export function normalizeUserCode(input: string): string {
  const letters = userCodeLetters(input);
  if (letters.length <= USER_CODE_HALF) {
    return letters;
  }
  return `${letters.slice(0, USER_CODE_HALF)}-${letters.slice(USER_CODE_HALF)}`;
}

export function isUserCode(value: string): boolean {
  return USER_CODE_PATTERN.test(value);
}
